/**
 * Auth store — CR-0030.
 * Manages token + user state. Persists to localStorage when "remember me"
 * is checked, sessionStorage otherwise.
 */
import { create } from "zustand";

const STORAGE_KEY = "mygenie_auth";
const REMEMBER_KEY = "mygenie_remember";

function loadPersistedAuth() {
  try {
    const remember = localStorage.getItem(REMEMBER_KEY) === "true";
    const store = remember ? localStorage : sessionStorage;
    const raw = store.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return { token: parsed.token || null, user: parsed.user || null, remember };
    }
  } catch {
    /* corrupted storage — ignore */
  }
  return { token: null, user: null, remember: false };
}

const initial = loadPersistedAuth();

const useAuthStore = create((set, get) => ({
  token: initial.token,
  user: initial.user,
  remember: initial.remember,

  setAuth: (token, user, remember) => {
    const store = remember ? localStorage : sessionStorage;
    localStorage.setItem(REMEMBER_KEY, String(remember));
    store.setItem(STORAGE_KEY, JSON.stringify({ token, user }));
    set({ token, user, remember });
  },

  clearAuth: () => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(REMEMBER_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    set({ token: null, user: null, remember: false });
  },

  isAuthenticated: () => !!get().token,
}));

export default useAuthStore;
